import { Button } from "@/components/ui/button";

interface OptionItemProps extends React.ComponentProps<typeof Button> {
  icon: React.ReactNode;
  title: string;
}

export default function OptionItem({ icon, title, ...props }: OptionItemProps) {
  return (
    <Button
      className="flex h-[37px] w-full justify-start gap-2 rounded-[10px] px-2 transition-colors hover:bg-white/10"
      {...props}
    >
      {icon}
      <span className="text-14 text-white">{title}</span>
    </Button>
  );
}
